

















export default {
  name: 'TopBar',
  props: {
    hideDefaultLogo: {
      type: Boolean,
      default: false,
    },
  },
};
